import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import Loading from '@components/common/loading';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { showSucsessMessage } from '@services/notifyService';
import { getDetailRestaurantSuccess } from '@store/actions/restaurant';
import { Card } from 'antd';
import moment from 'moment';

import { MediaKinds, TIME_FORMAT_DISPLAY } from '../../../constants';
import { daysOfWeekTimeWork } from '../../../constants/masterData';

import QrCodeLiveSettingForm from './QrCodeLiveSettingForm';

const RestaurantQrCodeLivePage = () => {
    const dispatch = useDispatch();
    const { restaurantId } = useParams();
    const translate = useTranslate();
    const [ isGetDetailLoading, setIsGetDetailLoading ] = useState(false);
    const [ dataDetail, setDataDetail ] = useState({});
    const [ deviceList, setDeviceList ] = useState([]);
    const [ isChangedFormValues, setIsChangedFormValues ] = useState(false);
    const [rawGeneralTimeWork, setRawGeneralTimeWork] = useState(null);

    const getDetail = (restaurantId) => {
        setIsGetDetailLoading(true);
        executeGet({
            pathParams: { id: restaurantId },
            onCompleted: (response) => {
                const settings = JSON.parse(response.data.settings || '{}');
                setRawGeneralTimeWork(settings.general_time_work);

                const mappedData = getDataDetailMapping(response.data);
                setDataDetail(mappedData);
                setIsGetDetailLoading(false);
            },
            onError: () => {
                setIsGetDetailLoading(false);
            },
        });
    };

    const getMyDevices = (id) => {
        myDevices({
            pathParams: { id: restaurantId },
            onCompleted: (response) => {
                if (response?.result) {
                    setDeviceList(response.data?.content || []);
                }
            },
            onError: () => {},
        });
    };

    const updateDeviceMediaHandler = (id, mediaCode) => {
        // showFullScreenLoading();
        // dispatch(
        //     updateDeviceMedia({
        //         params: { id, mediaCode },
        //         onCompleted: () => {
        //             hideFullScreenLoading();
        //         },
        //         onError: () => {
        //             hideFullScreenLoading();
        //         },
        //     }),
        // );
    };

    const prepareUpdateData = (settingObj) => {
        const newSettingObj = { ...settingObj };
        if (newSettingObj.tablet_random.time_work) {
            const { dayOffs, ...timeWorkData } = newSettingObj.tablet_random.time_work;
            const timeWorkObj = { dayOffs };
            Object.keys(timeWorkData).forEach((timeWorkKey) => {
                timeWorkObj[timeWorkKey] = timeWorkData[timeWorkKey].map(
                    (timeWorkItem) => `${timeWorkItem.from.format('HH:mm')}-${timeWorkItem.to.format('HH:mm')}`,
                );
            });
            newSettingObj.tablet_random.time_work = timeWorkObj;
        }
        if (newSettingObj.paymentQrlive) {
            newSettingObj.paymentQrlive = newSettingObj.paymentQrlive.map((pmt) => ({ code: pmt }));
        }

        newSettingObj.tablet_random.device_medias = deviceList.map((device) => ({
            device_id: device.id,
            media_code: newSettingObj.tablet_random.device_medias[device.id]?.media_code || '',
            device_token: device.deviceToken,
        }));
        newSettingObj.general_time_work = rawGeneralTimeWork;

        return { ...dataDetail, settings: JSON.stringify(newSettingObj) };
    };

    const getTimeWorkTabletRandomData = (timeWork) => {
        let timeWorkData = { dayOffs: [] };
        if (timeWork) {
            daysOfWeekTimeWork.forEach((day) => {
                timeWorkData[day.value] = timeWork[day.value].map((timeWorkItem) => {
                    const timeWorkStr = timeWorkItem.split('-');
                    return {
                        from: moment(timeWorkStr[0], TIME_FORMAT_DISPLAY),
                        to: moment(timeWorkStr[1], TIME_FORMAT_DISPLAY),
                    };
                });
            });
            timeWorkData.dayOffs = timeWork.dayOffs;
        } 
        else {
            daysOfWeekTimeWork.forEach((day) => {
                timeWorkData[day.value] = [
                    { from: moment('00:00', TIME_FORMAT_DISPLAY), to: moment('00:00', TIME_FORMAT_DISPLAY) },
                    { from: moment('00:00', TIME_FORMAT_DISPLAY), to: moment('00:00', TIME_FORMAT_DISPLAY) },
                ];
            });
        }
        return timeWorkData;
    };

    const getDataDetailMapping = (data) => {
        const dataDetail = { ...data };
        dataDetail.settings = JSON.parse(data.settings) || {};
        if (!dataDetail.settings.tablet_random) {
            dataDetail.settings.tablet_random = {};
        }
        const privateTime = dataDetail.settings.tablet_random.time_work || {};
        const generalTime = dataDetail.settings.general_time_work || {};

        const hasPrivateTimeWork = Object.values(privateTime).some(
            val => Array.isArray(val) && val.length > 0,
        );

        if (hasPrivateTimeWork) {
            dataDetail.settings.tablet_random.time_work = getTimeWorkTabletRandomData(privateTime);
            dataDetail.settings.tablet_random.enable_time_work = true;
        } else {
            const sourceTime = (generalTime && Object.keys(generalTime).length > 0) ? generalTime : null;
        
            dataDetail.settings.tablet_random.time_work = getTimeWorkTabletRandomData(sourceTime);
            dataDetail.settings.tablet_random.enable_time_work = false;
        }

        dataDetail.settings.general_time_work = getTimeWorkTabletRandomData(
            (generalTime && Object.keys(generalTime).length > 0) ? generalTime : null,
        );
        dataDetail.settings.tablet_random.media_kind = dataDetail.settings.tablet_random.media_kind || MediaKinds.IMAGE;
    
        dataDetail.settings.tablet_random.device_medias = (dataDetail.settings.tablet_random.device_medias || []).reduce((result, media) => {
            result[media.device_id] = media;
            return result;
        }, {}) || {};
        if (dataDetail.settings.paymentQrlive) {
            dataDetail.settings.paymentQrlive = dataDetail.settings.paymentQrlive.map((pmt) => pmt.code);
        } else {
            dataDetail.settings.paymentQrlive = [];
        }
        return dataDetail;
    };

    const onSave = (values) => {
        const updatedData = prepareUpdateData(values);
        update({
            data: updatedData,
            onCompleted: (res) => {
                showSucsessMessage(translate.formatMessage(commonMessage.updateQrCodeLiveSuccess), translate);
                executeGet({
                    pathParams: { id: restaurantId },
                    onCompleted: (response) => {
                        const mappedData = getDataDetailMapping(response.data);
                        setDataDetail(mappedData);
                        dispatch(getDetailRestaurantSuccess({ payload: { data: response.data } }));
                        setIsGetDetailLoading(false);
                    },
                });
            },
            onError: () => {},
        });
    };

    const { execute: executeGet, loading } = useFetch(apiConfig.restaurant.getById, {
        immediate: false,
    });

    const { execute: myDevices } = useFetch(apiConfig.device.myDevicesSetting, {
        immediate: false,
    });

    const { execute: uploadFile } = useFetch({
        ...apiConfig.file.upload,
        isRequiredTenantId: true,
    });

    const { execute: update, loading: loadingUpdate } = useFetch(apiConfig.restaurant.updateByCustomer);

    useEffect(() => {
        if (restaurantId) {
            getDetail(restaurantId);
            getMyDevices(restaurantId);
        }
    }, [ restaurantId ]);

    const renderActions = () => {
        return [];
    };

    const getFormId = () => {
        return 'qr-live-setting-form';
    };

    if (isGetDetailLoading) {
        return <Loading />;
    }

    return (
        <PageWrapper
            loading={loading}
            routes={[ { breadcrumbName: translate.formatMessage(commonMessage.restaurantsQrCodeLive) } ]}
        >
            <div className="basic-form-page">
                <Card
                    title={translate.formatMessage(commonMessage.qrCodeLive)}
                    bordered={false}
                    actions={renderActions()}
                >
                    <QrCodeLiveSettingForm
                        formId={getFormId()}
                        onSubmit={onSave}
                        settingObj={dataDetail.settings}
                        uploadFile={uploadFile}
                        setIsChangedFormValues={setIsChangedFormValues}
                        deviceList={deviceList}
                        updateDeviceMedia={updateDeviceMediaHandler}
                        isChangedFormValues={isChangedFormValues}
                        loadingUpdate={loadingUpdate}
                    />
                </Card>
            </div>
        </PageWrapper>
    );
};

export default RestaurantQrCodeLivePage;
